import * as types from '../actionType';

export const setMaterialNamesList = (materialNamesList) => ({
  type: types.SET_MATERIAL_NAMES_LIST,
  payload: materialNamesList,
});

export const setMaterialConfigsState = (name, config) => ({
  type: types.SET_MATERIAL_CONFIGS_STATE,
  payload: { name, config },
});